import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import Table from '../../components/Table';

function TestLots() {
  const [test_lots, setTestLots] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);

  const columns = [
    {
      title: 'Código do Lote',
      field: 'lot.code',
      hideFilterIcon: true,
    },
    {
      title: 'Parametros',
      field: 'parameters',
      render: (rowData) => {
        let parameters = '';
        rowData.parameters.map((parameter) => parameters += (`${parameter.parameter.name}, `));
        return (
          parameters.slice(0, -2)
        );
      },
      hideFilterIcon: true,
      editable: 'never',
    },
    {
      title: 'Data',
      field: 'date',
      type: 'date',
      hideFilterIcon: true,
    },
    {
      title: 'Observação',
      field: 'observation',
      hideFilterIcon: true,
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/test-lots');
        await response.data.map((biomeasure) => {
          if (biomeasure.description && biomeasure.description.length > 15) {
            biomeasure.description = `${biomeasure.description.substr(0, 15)}...`;
          }
        });
        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          setTestLots(response.data);
          setOpenProgress(true);
        }
      } catch (err) {
      }
    } loadData();
  }, []);

  function setData(newData) {
    const tempData = [];
    test_lots.map((biomeasure) => (
      biomeasure.id === newData.id ? tempData.push(newData) : tempData.push(biomeasure)
    ));
    setTestLots(tempData);
  }

  return (
    <Table title="Qualidade da Larva" route="/test-lots/" routeAdd="/test-lot/" columns={columns} data={test_lots} setData={setData} dataLoaded={openProgress} />
  );
}

export default TestLots;
